/* eslint no-param-reassign: "error" */

import { Component } from 'react'
import _ from 'lodash'
import { hot } from 'react-hot-loader/root'
import { jumbogrove } from 'jumbogrove/dist/jumbogrove.common'
import './styles.scss'

function initJumbogrove(situations) {
  jumbogrove('#game', {
    id: 'demo',
    showAside: false,
    init: (model, ui) => {
      ui.addTemplateGetters({
        isWoman: () => model.character('me').getQuality('gender') === 'femme',
      })
    },
    characters: [
      {
        id: 'me',
        name: 'Me',
        qualities: {
          main: {
            gender: {
              name: 'Genre',
              type: 'raw',
              initialValue: '-',
            },
          },
        },
      },
    ],
    situations: [...situations],
  })
}

function start() {
  const situationsRequires = require.context('./scenarii/gdt', true, /\.js$/)
  const situations = _.flatten(situationsRequires.keys().map(key => situationsRequires(key).default))
  initJumbogrove(situations)
}

class App extends Component {
  componentDidMount() {
    start()
  }

  render() {
    return null
  }
}

export default hot(App)
